export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'fln';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'fln-site@tacom.com.br';
export const password = '4fL*1tE12DxE';

export const versaoSoftware = '4.4.19';
export const idioma = 'pt_BR'

export default {
}
